export default "__VITE_ASSET__DRi8a2hz__"